export enum InfoBarTypes {
  INFO = 'info',
  ERROR = 'error'
}
